import React from "react";
import SympotmFormPage from "../components/sympotms/SympotmFormPage";

const SympotmEdit = () => <SympotmFormPage mode="edit" />;

export default SympotmEdit;
